import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all scheduling groups
export const getSchedulingGroups = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/scheduling-group`);
    return response.data;
  } catch (error) {
    console.error('Error fetching scheduling groups:', error.response?.data || error);
    throw error;
  }
};

// GET a single scheduling group
export const getSchedulingGroupById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/scheduling-group/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching scheduling group:', error.response?.data || error);
    throw error;
  }
};

// CREATE a new scheduling group
export const createSchedulingGroup = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/scheduling-group`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating scheduling group:', error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing scheduling group
export const updateSchedulingGroup = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/scheduling-group/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating scheduling group:', error.response?.data || error);
    throw error;
  }
};

// DELETE a scheduling group
export const deleteSchedulingGroup = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/scheduling-group/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting scheduling group:', error.response?.data || error);
    throw error;
  }
};
